import { Fragment } from 'react'
import useArticles from 'hooks/use_articles'
import ArticleListItem from 'components/article_list_item/v2'
import { EmailCollectWrapper } from '../email_collect'
import InfiniteScroll from 'react-infinite-scroller'
import { Container, Col, Row } from 'components/grid'
import PropTypes from 'prop-types'

const InfiniteArticles = ({
  // Set of articles on the page of the containing component that aren't included in initialArticles
  addToFilter = [],
  contentfulQuery = {},
  initialArticles,
  perPage = 9,
  withBig,
}) => {
  const { articles, fetchArticles, hasMore } = useArticles({
    articles: initialArticles,
    filterIds: addToFilter.map(a => a.id),
    contentfulQuery,
    perPage,
  })
  const [bigFst, bigSnd, ...restArticles] = articles // for the version with two big articles on top

  const earlyEmailCollect = initialArticles.length <= 5

  // if using the big view, exclude the first two articles from the infinite scroll
  const showArticles = withBig ? restArticles : articles

  // fetch enough articles to fill out rows of 3
  const numToFetch = perPage - (showArticles.length % 3)

  return (
    <div className="mt-3 mtx-2">
      <Container>
        {withBig && (
          <Row>
            {bigFst && <ArticleListItem big article={bigFst} />}
            {bigSnd && <ArticleListItem big article={bigSnd} />}
          </Row>
        )}
        <InfiniteScroll loadMore={() => fetchArticles(numToFetch)} hasMore={hasMore}>
          {/* if there are fewer than 5 articles, the email collect box
          --* goes at the front--otherwise, it goes after the first 6
          --*/}
          <Row>
            {showArticles.map((a, idx) => {
              if (idx === 0 && earlyEmailCollect) {
                return (
                  <Fragment key={a.id}>
                    <Col xs={12}>
                      <EmailCollectWrapper />
                    </Col>
                    <ArticleListItem article={a} />
                  </Fragment>
                )
              } else if (idx === 6) {
                return (
                  <Fragment key={a.id}>
                    <Col xs={12}>
                      <EmailCollectWrapper />
                    </Col>
                    <ArticleListItem article={a} />
                  </Fragment>
                )
              } else {
                return <ArticleListItem article={a} key={a.id} />
              }
            })}
          </Row>
        </InfiniteScroll>
      </Container>
    </div>
  )
}

InfiniteArticles.propTypes = {
  addToFilter: PropTypes.array,
  contentfulQuery: PropTypes.object,
  initialArticles: PropTypes.array.isRequired,
  perPage: PropTypes.number,
  withBig: PropTypes.bool,
}

export default InfiniteArticles
